// src/components/BottomNavigation.jsx
import React from 'react';
import { FiGrid, FiMap } from 'react-icons/fi';
import './../styles/BottomNavigation.css';

const BottomNavigation = ({ activeView, onNavigate, className }) => {
  const handleNavClick = (data, view) => {
    if (onNavigate) {
      onNavigate({ data, view });
    }
  };

  // activeView is an object: { dataMode: 'openhouses'|'demo'|'listings', viewMode: 'gallery'/'map' }
  const isGalleryActive = (activeView.dataMode === 'openhouses' || activeView.dataMode === 'demo' || activeView.dataMode === 'listings') && activeView.viewMode === 'gallery';
  const isMapActive = (activeView.dataMode === 'openhouses' || activeView.dataMode === 'demo' || activeView.dataMode === 'listings') && activeView.viewMode === 'map';

  return (
    <nav id="mobile-bottom-nav" className={`bottom-navigation ${className || ''}`}>
      <div className="bottom-nav-section">
        <div className="buttons-group">
          <button
            className={`nav-button ${isGalleryActive ? 'active' : ''}`}
            onClick={() => handleNavClick(activeView.dataMode, 'gallery')}
            aria-label="Gallery"
          >
            <FiGrid />
            <span className="button-label">Gallery</span>
          </button>
          <button
            className={`nav-button ${isMapActive ? 'active' : ''}`}
            onClick={() => handleNavClick(activeView.dataMode, 'map')}
            aria-label="Map"
          >
            <FiMap />
            <span className="button-label">Map</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default BottomNavigation;
